/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useState} from 'react'
import ReactModal from 'react-modal';
import { checkAssistant } from '../../../redux/helper/CheckAssistant';
import AddressChangeModal from '../../AddressChangeModal';
import AddressHover from '../../AddressChangeModal/AddressHover'

export default function ItemDetailsSection({prod,OrderData,addressDropdown,handleUpdateAddress,GroupCategory,setGroupCategoryValue,groupIdx}) {
    const [viewAddress, setviewAddress] = useState('');
    const [addressPopup, setaddressPopup] = useState(false);
    const [addresmodal, setaddresmodal] = useState('');
    const ChangeShow = !checkAssistant() &&  OrderData?.order?.status === "0"
    const setOrderDetails=()=>{
        const copyData = {...OrderData}

    }
    return (
        <div className="w-full lg:px-2 mt-2.5 mb-3.5">
            <div className="flex items-center xl:flex-row flex-col">
                <div className="xl:w-[40%] w-full pl-4 pr-2 pb-2 pt-2.5 bg-[#F5F5FA] rounded-lg flex flex-wrap justify-start xl:mr-4">
                    <div className="pr-2 border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                        <p className="text-xs font-semibold text-[#808285]">Standard Pack Size</p>
                        <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{prod?.PACKING_SIZE||1} {prod?.PRIMARY_UOM_CODE}</p>
                    </div>
                    <div className="px-2 sm:border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                        <p className="text-xs font-semibold text-[#808285]">Size</p>
                        <p className="sm:text-xs6 text-sm font-semibold text-[#555259]"><>{`${prod.DIAMETER!==null ?`${prod.DIAMETER}mm`:''}`}</>
                            <>{`${prod.LENGTH!==null && prod.DIAMETER ? 'x':'-'}`}</>
                            <>{`${prod.LENGTH!==null ?`${prod.LENGTH}mm`:''}`}</></p>
                    </div>
                    <div className="sm:pl-2 pt-2 sm:pt-0">
                        <p className="text-xs font-semibold text-[#808285]">MOQ</p>
                        <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{prod?.MINIMUM_ORDER_QUANTITY}</p>
                    </div>
                </div>
                <div 
                    
                    className="xl:w-[60%] w-full flex sm:nowrap flex-wrap justify-start px-4 pt-2.5 pb-2 shadow-s9 rounded-lg xl:mt-0 mt-3 relative">
                    <button
                        onClick={()=>{
                            if(viewAddress===''){
                                setviewAddress('billing');

                            }else{
                                setviewAddress('')
                            }
                            setGroupCategoryValue(Object.keys(OrderData.order.items)[groupIdx])

                        }} type="button" className="pr-2 border-r border-[#CECECE] flex justify-between items-center xl:auto sm:w-1/2 w-full text-left showAddress-full2">
                        <div className="w-[85%] ">
                            <p className="text-xs font-semibold text-[#808285]">Billing address</p>
                            <p className="text-xs6 font-semibold text-[#555259] more-lines">{prod.BILLING_ADDRESS.ADDRESS1}</p>
                        </div>
                        <p className="font-semibold text-xs12 text-[#808285] cursor-pointer w-[15%]">{ChangeShow?'Change':'View'}</p>
                    </button>
                    {viewAddress==='billing' && <AddressHover type="billing" address={prod.BILLING_ADDRESS} setaddressPopup={setaddressPopup} NoChange={ChangeShow}/>}

                    <div 
                        onClick={()=>{
                            if(viewAddress===''){
                                setviewAddress('shipping')
                            }else{
                                setviewAddress('')
                            }
                            setGroupCategoryValue(Object.keys(OrderData.order.items)[groupIdx])

                        }}
                        className="sm:px-2 px-0 xl:auto sm:w-1/2 w-full flex justify-between items-center sm:mt-0 mt-2 relative">
                        <div className="w-[85%] cursor-pointer">
                            <p className="text-xs font-semibold text-[#808285]">Shipping address</p>
                            <p className="text-xs6 font-semibold text-[#555259] more-lines">{prod.SHIPPING_ADDRESS.ADDRESS1}</p>
                        </div>
                        <p className="font-semibold text-xs12 text-[#808285] cursor-pointer w-[15%]">{ChangeShow?'Change':'View'}</p>
                    </div>
                    {viewAddress==='shipping' && <AddressHover type="shipping" address={prod.SHIPPING_ADDRESS} setaddressPopup={setaddressPopup} NoChange={ChangeShow}/>}
                </div>
            </div>
            <ReactModal isOpen={addressPopup}>
                <AddressChangeModal
                    prod={prod}
                    addressPopup={addressPopup}
                    setaddressPopup={setaddressPopup}
                    OrderDetails={OrderData.order}
                    setOrderDetails={setOrderDetails}
                    addressDropdown={addressDropdown}
                    GroupCategory={GroupCategory}
                    setaddresmodal={setaddresmodal}
                    handleUpdateAddress={handleUpdateAddress}
                />
            </ReactModal>
        </div>
    )
}
